<template>
  <div class="container-filtro-relatorio" @click="toogleActive">
    <SvgIcon iconName="icon-excel" class="fill-maino-green" />
    <div class="container-options" v-if="filterActive">
      <div class="subcontainer-options">
        <div
          v-for="(option, index) in options"
          :key="index"
          class="option"
          @click="atualizar(option.id)"
        >
          {{ option.name }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SvgIcon from '../../../../shared/SvgIcon.vue';
import { normalizarParamsMultiselect } from '../../helpers/index';

export default {
  name: 'PedidoRelatorios',
  components: {
    SvgIcon,
  },
  props: {
    limiteExportacao: { type: Number, default: 10000 },
    mensagemLimite: { type: String, default: '' },
  },
  data() {
    return {
      options: [
        { id: 'pedidos', name: this.$i18n('interface.pedidos_index.exportar_relatorio_de_pedidos') },
        { id: 'processos', name: this.$i18n('interface.pedidos_index.exportar_relatorio_de_processos') },
      ],
      filterActive: false,
      path: window.location.pathname,
    };
  },
  methods: {
    lerTodosFiltrados() {
      return document.querySelector('#todos_filtrados')?.value === 'true';
    },
    lerIdsSelecionados() {
      return Array.from(document.querySelectorAll('.check_box_acoes_em_massa:checked')).map((el) => el.value);
    },
    lerTotalFiltrado() {
      const banner = document.querySelector('.tr-selecionar-todos-pedidos');
      return parseInt(banner?.dataset.totalFiltrados, 10) || 0;
    },
    passouLimiteExportacao() {
      const totalFiltrado = this.lerTotalFiltrado();
      if (totalFiltrado <= this.limiteExportacao) return true;
      const mensagem = this.mensagemLimite.replace('__COUNT__', totalFiltrado.toLocaleString('pt-BR'));
      window.exibe_mensagem_com_status(mensagem, 'warning');
      return false;
    },
    atualizar(id) {
      this.filterActive = false;
      const todosFiltrados = this.lerTodosFiltrados();
      const idsSelecionados = this.lerIdsSelecionados();

      if (!todosFiltrados && idsSelecionados.length === 0) {
        window.exibe_mensagem_com_status(this.$i18n('interface.pedidos_index.nenhum_pedido_selecionado'), 'warning');
        return;
      }
      if (todosFiltrados && !this.passouLimiteExportacao()) return;

      const paramsNormalizados = normalizarParamsMultiselect(new URLSearchParams(window.location.search));
      paramsNormalizados.set('origem_relatorio', id);
      if (todosFiltrados) {
        paramsNormalizados.set('todos_filtrados', 'true');
      } else {
        idsSelecionados.forEach((idPedido) => paramsNormalizados.append('pedido_ids[]', idPedido));
      }
      $.rails.ajax({
        url: `${this.path}.xlsx?${paramsNormalizados.toString()}`,
        dataType: 'json',
        success: (res) => {
          window.exibe_mensagem_com_status(res.notice, 'notice');
        },
        error: (xhr) => {
          const mensagem = (xhr && xhr.responseJSON && xhr.responseJSON.error)
            || this.$i18n('interface.pedidos_index.erro_exportar_relatorio');
          window.exibe_mensagem_com_status(mensagem, 'warning');
        },
      });
    },
    toogleActive() {
      this.filterActive = !this.filterActive;
    },
    fecharAoClicarFora(event) {
      const el = this.$el;
      if (this.filterActive && el && !el.contains(event.target)) {
        this.filterActive = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.fecharAoClicarFora);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.fecharAoClicarFora);
  },
};
</script>
